export const FOCUS_ADDRESS = "0x6e0236ea3729A131ef584c2159A5edD292F6E637";
export const AIRDROP_ADDRESS = "0x48a235c9BcE9a30bF0b728eB7eda827039949936";
export const MINTER_ADDRESS = "0xd89A34122360588afb6757D34B6404b41817288B";
